import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderInfo from '../../../../../Components/Common/HeaderInfo';

function BlockAAndBReport() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});

  // Fetch data from localStorage when component mounts
  useEffect(() => {
    const fetchData = () => {
      try {
        const balanceSheetData = localStorage.getItem('balanceSheetFormData');
        if (balanceSheetData) {
          const parsedData = JSON.parse(balanceSheetData);
          setFormData(parsedData);
        } else {
          console.log('No balanceSheet data found in localStorage');
        }
      } catch (error) {
        console.error('Error fetching data from localStorage:', error);
      }
    };

    fetchData();
  }, []);

  const handleCancel = () => {
    navigate('/report-selection');
  };

  const surveyYear = formData.year || formData.surveyYear || '2022-23';

  // Helper function to format date from ISO string to DD-MM-YYYY format
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      // Format as DD-MM-YYYY
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (error) {
      return dateString;
    }
  };

  return (
    <>
      <style>
        {`
         table thead tr th, table tbody tr td  {
          width: 50%;
          text-align: left;
          font-size:12px;
         }
         table thead tr th input, table tbody tr td input  {
          width:100%;
          max-width:120px;
          display:inline-block;
          text-align: left;
          height:28px;
           font-size:14px;
         }
         table tbody tr td label {
          color: #444;
          font-size: 14px;
          font-weight: 400;
          margin-bottom: 0;
         }

         /* Print Styles */
         @media print {
           @page {
             size: A4 landscape;
             margin: 5mm !important;
           }

           body * {
             visibility: hidden;
           }

           .card, .card * {
             visibility: visible;
           }

           .card {
             position: absolute;
             left: 0;
             top: 0;
             width: 100%;
             margin: 0 !important;
             padding: 0 !important;
             box-shadow: none !important;
             border: none !important;
           }

           .card-body {
             padding: 5px !important;
           }

           /* Compact header section */
           .row {
             margin: 0 !important;
             margin-bottom: 5px !important;
           }

           h4 {
             font-size: 16px !important;
             margin: 5px 0 !important;
             padding: 0 !important;
           }

           h6 {
             font-size: 10px !important;
             margin: 2px 0 !important;
             padding: 0 !important;
             line-height: 1.2 !important;
           }

           h3 {
             font-size: 14px !important;
             margin: 5px 0 !important;
             padding: 0 !important;
           }

           h5 {
             font-size: 12px !important;
             margin: 5px 0 !important;
             padding: 0 !important;
           }

           p {
             font-size: 10px !important;
             margin: 3px 0 !important;
             padding: 0 !important;
             line-height: 1.2 !important;
           }

           /* Hide action buttons and other elements */
           .no-print,
           .btn,
           button,
           hr,
           .row.no-print,
           .row.no-print * {
             display: none !important;
             visibility: hidden !important;
           }

           /* Compact table styles */
           table {
             width: 100% !important;
             border-collapse: collapse !important;
             page-break-inside: auto !important;
             margin: 0 !important;
             font-size: 9px !important;
           }

           table.table {
             margin-bottom: 5px !important;
           }

           tr {
             page-break-inside: avoid !important;
             page-break-after: auto !important;
             height: auto !important;
             min-height: 18px !important;
           }

           th, td {
             border: 1px solid #000 !important;
             padding: 2px 4px !important;
             vertical-align: top !important;
             font-size: 9px !important;
             line-height: 1.2 !important;
           }

           /* Compact form labels and inputs */
           .form-label {
             font-size: 9px !important;
             margin: 0 !important;
             margin-bottom: 1px !important;
             padding: 0 !important;
             line-height: 1.2 !important;
             display: block !important;
           }

           .form-input,
           .form-control {
             font-size: 9px !important;
             height: 18px !important;
             min-height: 18px !important;
             padding: 1px 3px !important;
             margin: 0 !important;
             margin-bottom: 2px !important;
             line-height: 1.2 !important;
             border: 1px solid #000 !important;
           }

           /* Compact nested tables */
           table table {
             font-size: 8px !important;
           }

           table table th,
           table table td {
             padding: 1px 3px !important;
             font-size: 8px !important;
           }

           table table .form-label {
             font-size: 8px !important;
             margin-bottom: 0 !important;
           }

           table table .form-input {
             font-size: 8px !important;
             height: 16px !important;
             min-height: 16px !important;
             padding: 1px 2px !important;
           }

           /* Declaration section compact */
           .declaration-section {
             margin-top: 5px !important;
             padding: 0 !important;
           }

           .declaration-section .row {
             margin-bottom: 3px !important;
           }

           .declaration-section .col-3,
           .declaration-section .col-6 {
             padding: 0 5px !important;
           }

           /* Hide HeaderInfo if present */
           .header-info,
           .header-info * {
             display: none !important;
             visibility: hidden !important;
           }

           /* Remove extra spacing */
           .text-center {
             padding: 0 !important;
           }

           /* Optimize column spacing */
           .col-12 {
             padding: 0 5px !important;
           }
         }
        `}
      </style>

      <div className="container-fluid">
        <div className="card mx-3 mb-3">
          <div className="card-body">
            {/* Header Section */}
            <div className="row">
              <div className="col-12 text-center">
                <h4 className='text-primary'>Annual Survey of Industries {surveyYear} (Part-I)</h4>
                <h6>Government of India, Ministry of Statistics and Programme Implementation</h6>
                <h6>Return under Collection of Statistics Act, 2008 and Rules framed there under in 2011</h6>
                <h6>(Please read the instructions before filling the return)</h6>
              </div>
            </div>
            {/* Block A and B Section */}
            <div className="row">
              <div className="col-12 text-center">
                <h3 className='text-primary fw-bold'>Block A and B</h3>
              </div>
            </div>
            <div className="row">
              <div className="col-12 text-center">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th style={{ width: '50%' }}>
                        Block A: Identification Particulars (For Official use)
                      </th>
                      <th style={{ width: '50%' }}>
                        Block B: Particulars of the Factory (To be filled by owner of the factory)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {/* Block A */}
                      <td style={{ width: '50%', verticalAlign: 'top' }}>
                        <table className="table">
                          <tbody>
                            <tr>
                              <td>
                                <label className="form-label">1. Schedule Despatch No.:</label>
                                <input type="text" className="form-input" value={formData.dslNo || '404936'} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">2. PSL No.:</label>
                                <input type="text" className="form-input" value={formData.pslNo || '31186'} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">3. Scheme Code (Census-1, Sample-2):</label>
                                <input type="text" className="form-input" value={formData.schemeCode || '2'} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">4. Ind. Code as per Frame (4-digit level of NIC-2008):</label>
                                <input type="text" className="form-input" value={formData.industryCodeFrame || '2392'} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">5. Ind. Code as per Return (5-digit level of NIC-2008):</label>
                                <input type="text" className="form-input" value={formData.industryCodeReturn || ''} disabled />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">6. Description of Industry:</label>
                                <input type="text" className="form-input" value={formData.descriptionOfIndustry || ''} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">7. State Code:</label>
                                <input type="text" className="form-input" value={formData.state || '09'} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">8. District Code:</label>
                                <input type="text" className="form-input" value={formData.district || '09'} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">9. Sector (Rural-1, Urban-2):</label>
                                <input
                                  type="text"
                                  className="form-input"
                                  value={formData.sector === '1' ? 'Rural' : formData.sector === '2' ? 'Urban' : ''}
                                  readOnly
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">10. RO/SRO Code:</label>
                                <input type="text" className="form-input" value={formData.roSroCode || '0912'} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">11. No. of units:</label>
                                <input type="text" className="form-input" value={formData.numberOfUnits || '1'} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">12. Status of unit (Code):</label>
                                <input type="text" className="form-input" value={formData.statusOfUnit || ''} readOnly />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>

                      {/* Block B */}
                      <td style={{ width: '50%', verticalAlign: 'top' }}>
                        <table className="table">
                          <tbody>
                            <tr>
                              <td>
                                <label className="form-label">1. Name and address of the Industrial Undertaking:</label>
                                <input type="text" className="form-input" value={formData.nameUnit || 'DEV BRICK FIELD'} readOnly />
                                <input type="text" className="form-input" value={formData.addressUnit || 'VILL-MATHURAPUR'} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">Town:</label>
                                <input type="text" className="form-input" value={formData.villTown || ''} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">District:</label>
                                <input type="text" className="form-input" value={formData.districtName || 'GHAZIABAD'} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">State Name:</label>
                                <input type="text" className="form-input" value={formData.stateName || 'Uttar Pradesh'} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">Pincode:</label>
                                <input type="text" className="form-input" value={formData.pinCode || ''} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">2. Type of organisation (Code):</label>
                                <input type="text" className="form-input" value={formData.typeOfOrg || ''} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">3. Corporate Identification Number (CIN):</label>
                                <input type="text" className="form-input" value={formData.cin || ''} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">
                                  4. Whether the unit has ISO Certification, 14000 Series (yes - 1, No-2):
                                </label>
                                <input
                                  type="text"
                                  className="form-input"
                                  value={formData.isoCert === '1' ? 'Yes' : formData.isoCert === '2' ? 'No' : ''}
                                  readOnly
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">5. Year of initial production:</label>
                                <input type="text" className="form-input" value={formData.yearOfInitialProd || ''} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">6. Accounting Year (MMYY to MMYY):</label>
                                <input type="text" className="form-input" value={formatDate(formData.accountingYearFrom)} readOnly />
                                <label className="form-label mt-1">To:</label>
                                <input type="text" className="form-input" value={formatDate(formData.accountingYearTo)} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">7. Number of months of operation:</label>
                                <input type="text" className="form-input" value={formData.monthsOfOperation || ''} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">
                                  8. Whether the share capital of the company includes share of foreign entities (yes-1, no-2):
                                </label>
                                <input
                                  type="text"
                                  className="form-input"
                                  value={formData.shareCapital === '1' ? 'Yes' : formData.shareCapital === '2' ? 'No' : ''}
                                  readOnly
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">
                                  9. Any R&D unit in your factory (yes registered with DST/DBT-1, yes registered with others-2, no-3):
                                </label>
                                <input type="text" className="form-input" value={formData.rdUnit || ''} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">10. Details of contact person:</label>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">i. Name & designation of contact person</label>
                                <input type="text" className="form-input" value={formData.contactName || ''} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">ii. Tele (with STD Code)</label>
                                <input type="text" className="form-input" value={formData.contactTele || ''} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">iii. FAX</label>
                                <input type="text" className="form-input" value={formData.contactFax || ''} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">iv. E-mail</label>
                                <input type="text" className="form-input" value={formData.contactEmail || ''} readOnly />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <label className="form-label">11. Whether the unit offered any formal training?:</label>
                                <input type="text" className="form-input" value={formData.formalTraining || ''} readOnly />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className='row'>
              <div className='col-12'>
                {/* Declaration Section */}
                <div className="declaration-section">
                  <h5 className="text-center text-primary fw-bold">DECLARATION</h5>
                  <p className="text-center">I hereby declare that information furnished in this return is correct and complete to the best of my knowledge and belief</p>

                  <div className='row'>
                    <div className='col-3'>
                      <label className="form-label">Date :</label>
                      <input type="text" className="form-control" value="" readOnly />
                    </div>
                    <div className='col-3'>
                      <label className="form-label">Place :</label>
                      <input type="text" className="form-control" value="" readOnly />
                    </div>
                    <div className='col-6'>
                      <label className="form-label">Name and Signature of owner with stamp</label>
                      <div style={{ height: '48px', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f5f5f5' }}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>




      {/* Action Buttons */ }

      < div className = "row no-print" >
        <div className="col-12">
          <hr />
        </div>
        <div className="col-md-8 text-center text-md-start mb-3 mb-md-0">
          <button
            type="button"
            className="btn btn_orange mx-1"
            onClick={() => window.print()}
          >
            Print
            <i className="fa fa-print ms-1"></i>
          </button>

          <button
            type="button"
            className="btn btn_orange mx-1"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
        <div className="col-md-4 text-center text-md-end">
          <button
            type="button"
            className="btn btn_orange mx-1"
            onClick={() => navigate(-1)}
          >
            <i className="fa fa-angle-left me-1"></i>
            Previous
          </button>
          <button
            type="button"
            className="btn btn_orange mx-1"
            onClick={() => navigate('/blockCreport')}
          >
            Next
            <i className="fa fa-angle-right ms-1"></i>
          </button>
        </div>
      </div >
    </>
  );
}

export default BlockAAndBReport;
